import { useCallback, useEffect, useState } from "react";
import api from "../../../services/api";

/**
 * Empresas (matriz + filiais) vinculadas ao projeto atual — mesma fonte do
 * backend que alimenta a tela de Arquivos (CNPJs dos SPEDs 0000 + cadastro do
 * projeto + certificados), consolidada pelo endpoint
 * GET /projects/:id/empresas-industriais.
 *
 * Usado na aba Parâmetros para classificar cada empresa como indústria ou
 * equiparada (ata reunião Diogo): o flag deixou de ser único por projeto e
 * passou a ser por CNPJ, persistido em atividadeIndustrialPorEmpresa no
 * documento do projeto.
 */
export default function useEmpresasIndustriais() {
  const [empresas, setEmpresas] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const projectId = localStorage.getItem("vidal_selected_project");

  const reload = useCallback(async () => {
    if (!projectId) {
      setLoading(false);
      return;
    }
    setLoading(true);
    setError(null);
    try {
      const resp = await api.get(`/projects/${projectId}/empresas-industriais`);
      setEmpresas(resp?.data?.empresas || []);
    } catch (err) {
      console.error("[useEmpresasIndustriais] Erro ao carregar empresas:", err);
      setError(err.message);
    } finally {
      setLoading(false);
    }
  }, [projectId]);

  useEffect(() => {
    reload();
  }, [reload]);

  const toggleIndustrial = async (cnpj, nextValue) => {
    // Atualização otimista — reverte se a chamada falhar.
    setEmpresas((prev) =>
      prev.map((e) => (e.cnpj === cnpj ? { ...e, atividadeIndustrial: nextValue } : e))
    );
    try {
      await api.patch(
        `/projects/${projectId}/empresas/${cnpj}/atividade-industrial`,
        { atividadeIndustrial: nextValue }
      );
    } catch (err) {
      console.error("[useEmpresasIndustriais] Erro ao salvar classificação industrial:", err);
      setEmpresas((prev) =>
        prev.map((e) => (e.cnpj === cnpj ? { ...e, atividadeIndustrial: !nextValue } : e))
      );
      throw err;
    }
  };

  return {
    projectId,
    empresas,
    loading,
    error,
    hasAlgumaIndustrial: empresas.some((e) => e.atividadeIndustrial),
    reload,
    toggleIndustrial,
  };
}
